import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const Gotop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button after scrolling 300px
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  // Scroll to top when clicked
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // smooth scroll
    });
  };

  return (
    <Wrapper>
      {isVisible && (
        <img
          src="/images/scroll-top-icon.png"
          alt="Scroll to top"
          onClick={scrollToTop}
        />
      )}
    </Wrapper>
  );
};

const Wrapper = styled.section`
  img {
    position: fixed;
    bottom: 10rem;
    right: 2rem;
    cursor: pointer;
    width: 49px;
    height: 49px;
    z-index: 1000;
  }

  @media (max-width: 768px) {
    img {
      width: 40px;
      height: 40px;
      bottom: 9rem;
      right: 2.4rem;
    }
  }
`;

export default Gotop;
